import { createFileRoute, redirect } from '@tanstack/react-router'
import { AdminReputation } from '@/components/admin/marketing/AdminReputation'
import { REPUTATION_INBOX_ENABLED } from '@/lib/reputationInbox'
import { getStoredUserRole, marketingLandingPath } from '@/lib/staff-roles'

export const Route = createFileRoute('/admin/marketing/reputation')({
  // While the inbox is hidden (lib/reputationInbox.ts) a bookmark or typed
  // URL lands on the Marketing landing page instead of a dead screen.
  beforeLoad: () => {
    if (!REPUTATION_INBOX_ENABLED) {
      throw redirect({ to: marketingLandingPath(getStoredUserRole()) })
    }
  },
  component: () => <AdminReputation />,
})
